import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';
import { LoginAccess } from '../../entities/login-access';
import { Credentials } from '../../entities/credentials';
import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { CachedCallService } from './cached-call.service';

@Injectable()
export class AuthenticationService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });
  private static readonly AuthenticationBaseUrl:string = `${Settings.apiUrl}/api/Authentication/Login`;
  public loginAccess:LoginAccess = null;
  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(
    @Inject(forwardRef(() => HttpClient)) private http:HttpClient
  ) { }

  public login(memberId:string, password:string): Promise<LoginAccess> {
    let credentials = new Credentials();

    credentials.ApplicationMemberId = (Settings.autoLoginEnabled) ? Settings.autoLoginMemberId : memberId;
    credentials.AccessKey = (Settings.autoLoginEnabled) ? Settings.autoLoginPassword : password;

    return this.cachedCallService.invokeSingleCall(
      () => this.http.post(AuthenticationService.AuthenticationBaseUrl, credentials)
      .toPromise()
      .then(response => {
        this.loginAccess = response.json();
        // TOOD: RP Add token to local storage

        HttpClient.authorization = this.loginAccess.AccessToken;
        return this.loginAccess;
      }),
      `login_${memberId}_${password}`
    );
  }

  public logout(){
    this.loginAccess = null;

    // TOOD: RP Remove token to local storage
    
    window.location.href = Settings.unauthorizedRedirectUrl;
  }

  public getLoginBaton(): Promise<string> {
    let authenticationUrl:string = `${Settings.apiUrl}/api/Authentication/IssueBaton`;

    return this.http.get(authenticationUrl)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  // TODO: RP Get token from LocalStorage, pass to API to see if User is still valid
  //       This is then consumed by auth-guard.service.ts to persist refresh
  //
  // public isUserValid(): Promise<boolean> {

  // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/authentication.service.ts